import { loadAppEntity } from './load-app-entity.js'
import { loadEntityTrackings } from './load-entity-trackings.js'

const appEntityData = {
  appEntity: null,
  trackings: null
}

export const browserAppEntity = {
  load: async function (params = {}) {
    const { accountingOrganisationId } = params
    if (!accountingOrganisationId) return

    // No need to load if already loaded
    if (!appEntityData.appEntity) {
      const loadedData = await loadAppEntity(accountingOrganisationId)
      appEntityData.appEntity = loadedData || null

      appEntityData.accountingOrganisationId = accountingOrganisationId
    }

    const promises = []
    if (params.includeTrackings && !appEntityData.trackings) {
      promises.push((async function () {
        const loadedTrackings = await loadEntityTrackings(accountingOrganisationId)
        appEntityData.trackings = loadedTrackings
      })())
    }

    await Promise.all(promises)
  },

  data: appEntityData
}
